<template>
    <div class="table">
        <div class="container"  element-loading-background = "rgba(255, 255,255,0.7)" :element-loading-text = "loadingText" v-loading="loading"  style="width:95%;">
            <el-form ref="form" :model="form" label-width="270px" style="height:80px;">
                <el-form-item  label="新学校获取已存在学校初始化数据设置：">
                    <el-select v-model="form.deptId" placeholder="请选择学校" clearable>
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="font-size: 14px; color: red; line-height: 25px; margin-left: 10px;">温馨提示：创建新的学校或者钉钉第三方企业绑定新企业会复制上面选中的学校数据到新的学校去。</div>
            <span slot="footer" class="dialog-footer" style="text-align:left;">
                <el-button type="primary"  @click="save()">确定</el-button>
            </span>
        </div>
        <el-divider></el-divider>
        <div class="container"
                element-loading-background = "rgba(255, 255,255,0.7)" 
                :element-loading-text = "loadingText2" v-loading="loading2"  style="width:95%;">
            <el-form ref="form2" :rules="rules" :model="form2" label-width="170px" style="height:80px;">
                <el-form-item  prop="deptId" label="清空全校师生绑定：">
                    <el-select v-model="form2.deptId" placeholder="请选择学校" clearable>
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:left;">
                <el-button type="primary" @click="dingUnbindBySchoolId(0)">确定清空全校师生钉钉绑定</el-button>
                <el-button type="primary" @click="dingUnbindBySchoolId(2)">确定清空全校教师钉钉绑定</el-button>
            </span>
        </div>
    </div> 
</template>

<script>
    import http from '../../../../common/http'

    export default {
        name:"",
        data(){
            return{
                loading:false,
                loadingText:"",
                loading2:false,
                loadingText2:"",
                form: {
                    deptId: ""
                },
                form2: {
                    deptId: "",
                    personType: ''
                },
                depts:[],
                rules: {
                    deptId:[
                        { required: true, message: '请选择学校', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
        },
        created:function () {
            this.getDeptData()
        },
        methods:{
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl
                let data = {parentId:"0"}
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.configListUrl
                let data = {};
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status===200){
                        this.form.deptId = res.data[0].configValue
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                this.loading=true;
                this.loadingText="正在保存中..."

                let url = this.configSaveUrl
                let reqJson = {}
                reqJson['public_param_defalut_school_source'] = this.form.deptId
                let data = {
                    data:JSON.stringify(reqJson)
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1)
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                })
            },
            dingUnbindBySchoolId(personType){
                this.$refs['form2'].validate((valid) => {
                    if(valid){
                        let deptName =""
                        this.depts.forEach(element => {
                            if(element.id === this.form2.deptId){
                                deptName = element.name
                            }
                        });

                        let tipMsg = ""
                        if(personType === 0){
                            tipMsg = "清空【"+deptName+"】师生钉钉绑定信息，是否继续？"
                            this.form2.personType = ""
                        }else{
                            tipMsg = "清空【"+deptName+"】教师钉钉绑定信息，是否继续？"
                            this.form2.personType = personType
                        }
                        this.$commonFn.showConfirm2(tipMsg, this.dingUnbindBySchoolIdSuccess)
                    }
                })
            },
            dingUnbindBySchoolIdSuccess(){
                this.loading2=true;
                this.loadingText2="正在清空中..."

                let url = this.userDingUnbindBySchoolIdUrl
                let data = {
                    'deptId': this.form2.deptId,
                    'personType': this.form2.personType
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1)
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading2=false
                },(err)=>{
                    console.log(err)
                    this.loading2=false
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/publicParam/index.vue